import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

// Globální volba „Popisek stanice" — která pole stanice (ID / Název / Plný název /
// Upřesnění) se zobrazují jako popisek řádku. Sdílené přes CELOU aplikaci:
// skupinové tabulky (jevy, měsíční/roční, měřené veličiny) i nabídka dotažení
// dat (FillPromptDialog, IncompleteDataBadge). Dřív per-produkt v useMeasStore /
// useGroupPeriodStore / useGroupJevyStore — sjednoceno, aby bylo jednoznačné.
//
// Pole a jejich pořadí: viz STATION_LABEL_FIELDS v
// components/group/shared/StationLabelFields.jsx.
export const useStationLabelStore = create(
  persist(
    (set) => ({
      labelFields: ['name'],
      setLabelFields: (labelFields) => set({ labelFields }),
    }),
    {
      name: 'station-label-store',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
)
